// 말소 탭 드롭존 → 신청 화면 파일 넘김 (B3 리뷰 P15). router state 에 File 을 싣지 않는다 —
// 모듈 변수 1개, 신청 화면이 mount 시 takeFiles() 로 가져가며 비운다.
var pending = [];

export function putFiles(files) { pending = Array.prototype.slice.call(files || []); }

export function takeFiles() { var out = pending; pending = []; return out; }
